import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { getPropiedades } from "../../firebase/propiedades";
import { enviarConsulta } from "../../firebase/consultas";
import logo from "../../logo.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const CHAJARI = [-30.7547, -57.9831];
const TIPOS = ["Casa", "Terreno", "Hectárea/Campo", "Departamento", "Local/Oficina"];

// Color del badge según estado
function colorEstado(estado) {
  if (estado === "Vendida") return "#8b1a1a";
  if (estado === "Alquilada") return "#7c3a00";
  if (estado === "No disponible") return "#374151";
  return "#1a9e2a"; // Disponible (no se muestra, pero por si acaso)
}

function AjustarBounds({ propiedades }) {
  const map = useMap();
  useEffect(() => {
    const conCoords = propiedades.filter(p => p.coordenadas?.lat && p.coordenadas?.lng);
    if (conCoords.length === 0) { map.setView(CHAJARI, 13); return; }
    if (conCoords.length === 1) { const c = conCoords[0].coordenadas; map.setView([c.lat, c.lng], 15); return; }
    const bounds = L.latLngBounds(conCoords.map(p => [p.coordenadas.lat, p.coordenadas.lng]));
    map.fitBounds(bounds, { padding: [40, 40], maxZoom: 16 });
  }, [propiedades, map]);
  return null;
}

export default function Listado() {
  const navigate = useNavigate();
  const [propiedades, setPropiedades] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [filtroTipo, setFiltroTipo] = useState("");
  const [consulta, setConsulta] = useState({ nombre: "", telefono: "", detalle: "", presupuesto: "" });
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [mostrarMapa, setMostrarMapa] = useState(true);

  useEffect(() => {
    getPropiedades().then((data) => { setPropiedades(data); setCargando(false); });
  }, []);

  function handleConsulta(e) {
    setConsulta({ ...consulta, [e.target.name]: e.target.value });
  }

  async function handleEnviar(e) {
    e.preventDefault();
    setEnviando(true);
    await enviarConsulta({
      nombre: consulta.nombre,
      telefono: consulta.telefono,
      mensaje: `${consulta.detalle} | Presupuesto aproximado: $${consulta.presupuesto}`,
      email: "",
      propiedadTitulo: "Consulta general",
    });
    setEnviando(false);
    setEnviado(true);
    setConsulta({ nombre: "", telefono: "", detalle: "", presupuesto: "" });
  }

  const filtradas = useMemo(() =>
    [...propiedades]
      .filter(p => {
        if (!filtroTipo) return true;
        const tipos = p.tipos || (p.tipo ? [p.tipo] : []);
        return tipos.includes(filtroTipo);
      })
      .sort((a, b) => (a.precio || 0) - (b.precio || 0)),
    [propiedades, filtroTipo]
  );

  const conCoordenadas = filtradas.filter(p => p.coordenadas?.lat && p.coordenadas?.lng);

  return (
    <div style={{ minHeight: "100vh", background: "#f4f4f4", fontFamily: "system-ui, sans-serif", overflowX: "hidden" }}>

      <nav style={{ background: "#f4f4f4", borderBottom: "1px solid #e5e5e5", padding: "12px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <img src={logo} alt="Confalonieri Propiedades" onClick={() => navigate("/")} style={{ height: "40px", cursor: "pointer" }} />
      </nav>

      <div style={{ height: "4px", background: "#1a9e2a" }} />

      {/* BANNER CONSULTA */}
      <div style={{ background: "#fff", borderBottom: "1px solid #e5e5e5", padding: "24px 20px" }}>
        <h3 style={{ fontSize: "16px", fontWeight: "700", color: "#111827", marginBottom: "4px", fontFamily: "Georgia, serif" }}>
          ¿No encontrás lo que buscás?
        </h3>
        <p style={{ fontSize: "13px", color: "#6b7280", marginBottom: "16px" }}>
          Dejanos tu consulta y te ayudamos a encontrar la propiedad ideal.
        </p>
        {enviado ? (
          <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: "10px", padding: "16px", textAlign: "center" }}>
            <p style={{ color: "#16a34a", fontWeight: "600", fontSize: "14px" }}>Consulta enviada! Nos pondremos en contacto a la brevedad.</p>
            <button onClick={() => setEnviado(false)} style={{ marginTop: "8px", fontSize: "12px", color: "#1a9e2a", background: "none", border: "none", cursor: "pointer", textDecoration: "underline" }}>
              Enviar otra consulta
            </button>
          </div>
        ) : (
          <form onSubmit={handleEnviar} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
              <div>
                <label style={{ fontSize: "11px", fontWeight: "600", color: "#6b7280", display: "block", marginBottom: "4px" }}>NOMBRE *</label>
                <input name="nombre" value={consulta.nombre} onChange={handleConsulta} required placeholder="Tu nombre" style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: "1px solid #e5e7eb", fontSize: "13px", outline: "none", boxSizing: "border-box" }} />
              </div>
              <div>
                <label style={{ fontSize: "11px", fontWeight: "600", color: "#6b7280", display: "block", marginBottom: "4px" }}>TELEFONO *</label>
                <input name="telefono" value={consulta.telefono} onChange={handleConsulta} required placeholder="Tu telefono" style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: "1px solid #e5e7eb", fontSize: "13px", outline: "none", boxSizing: "border-box" }} />
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
              <div>
                <label style={{ fontSize: "11px", fontWeight: "600", color: "#6b7280", display: "block", marginBottom: "4px" }}>PRESUPUESTO *</label>
                <input name="presupuesto" value={consulta.presupuesto} onChange={handleConsulta} required placeholder="Ej: $50,000" style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: "1px solid #e5e7eb", fontSize: "13px", outline: "none", boxSizing: "border-box" }} />
              </div>
              <div>
                <label style={{ fontSize: "11px", fontWeight: "600", color: "#6b7280", display: "block", marginBottom: "4px" }}>QUE BUSCAS? *</label>
                <input name="detalle" value={consulta.detalle} onChange={handleConsulta} required placeholder="Ej: Casa 3 ambientes" style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: "1px solid #e5e7eb", fontSize: "13px", outline: "none", boxSizing: "border-box" }} />
              </div>
            </div>
            <button type="submit" disabled={enviando} style={{ background: "#1a9e2a", color: "#fff", border: "none", borderRadius: "8px", padding: "12px", fontWeight: "700", fontSize: "14px", cursor: "pointer", opacity: enviando ? 0.6 : 1 }}>
              {enviando ? "Enviando..." : "Enviar consulta"}
            </button>
          </form>
        )}
      </div>

      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "24px 16px" }}>

        <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#111827", marginBottom: "16px", fontFamily: "Georgia, serif" }}>
          Propiedades disponibles
          {!cargando && (
            <span style={{ fontSize: "14px", fontWeight: "500", color: "#6b7280", marginLeft: "10px" }}>
              ({filtradas.length} {filtradas.length === 1 ? "resultado" : "resultados"})
            </span>
          )}
        </h2>

        {/* FILTROS */}
        <div style={{ display: "flex", gap: "8px", marginBottom: "20px", flexWrap: "wrap", alignItems: "center" }}>
          <button
            onClick={() => setFiltroTipo("")}
            style={{ padding: "8px 20px", borderRadius: "20px", border: "1px solid #1a9e2a", background: filtroTipo === "" ? "#1a9e2a" : "#fff", color: filtroTipo === "" ? "#fff" : "#1a9e2a", fontWeight: "600", fontSize: "13px", cursor: "pointer" }}
          >
            Todos
          </button>
          {TIPOS.map((tipo) => (
            <button
              key={tipo}
              onClick={() => setFiltroTipo(filtroTipo === tipo ? "" : tipo)}
              style={{ padding: "8px 20px", borderRadius: "20px", border: "1px solid #1a9e2a", background: filtroTipo === tipo ? "#1a9e2a" : "#fff", color: filtroTipo === tipo ? "#fff" : "#1a9e2a", fontWeight: "600", fontSize: "13px", cursor: "pointer" }}
            >
              {tipo}
            </button>
          ))}
          <button
            onClick={() => setMostrarMapa(!mostrarMapa)}
            style={{ padding: "8px 20px", borderRadius: "20px", border: "1px solid #6b7280", background: mostrarMapa ? "#6b7280" : "#fff", color: mostrarMapa ? "#fff" : "#6b7280", fontWeight: "600", fontSize: "13px", cursor: "pointer", marginLeft: "auto" }}
          >
            {mostrarMapa ? "Ocultar mapa" : "Mostrar mapa"}
          </button>
        </div>

        {/* MAPA */}
        {mostrarMapa && (
          <div style={{ marginBottom: "24px", borderRadius: "14px", overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", border: "1px solid #e5e7eb" }}>
            {conCoordenadas.length === 0 ? (
              <div style={{ height: "200px", display: "flex", alignItems: "center", justifyContent: "center", background: "#fff", color: "#9ca3af", fontSize: "13px", textAlign: "center", padding: "20px" }}>
                Las propiedades de este filtro todavia no tienen ubicacion cargada.
              </div>
            ) : (
              <div style={{ height: "400px" }}>
                <MapContainer center={CHAJARI} zoom={13} style={{ height: "100%", width: "100%" }}>
                  <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  <AjustarBounds propiedades={conCoordenadas} />
                  {conCoordenadas.map((p) => (
                    <Marker key={p.id} position={[p.coordenadas.lat, p.coordenadas.lng]}>
                      <Popup>
                        <div style={{ minWidth: "180px", fontFamily: "system-ui, sans-serif" }}>
                          {(p.imagenes?.[0] || p.imagen) && (
                            <img src={p.imagenes?.[0] || p.imagen} alt={p.titulo} style={{ width: "100%", height: "100px", objectFit: "cover", borderRadius: "6px", marginBottom: "8px" }} />
                          )}
                          <p style={{ fontWeight: "700", fontSize: "13px", color: "#111827", margin: "0 0 4px 0" }}>{p.titulo}</p>
                          <p style={{ fontSize: "11px", color: "#6b7280", margin: "0 0 6px 0" }}>{p.ubicacion}{p.barrio ? ` - ${p.barrio}` : ""}</p>
                          {(p.asfalto || p.gasNatural) && (
                            <div style={{ display: "flex", gap: "4px", flexWrap: "wrap", marginBottom: "6px" }}>
                              {p.asfalto && <span style={{ fontSize: "10px", background: "#f0fdf4", color: "#166534", padding: "2px 6px", borderRadius: "10px", border: "1px solid #bbf7d0" }}>Asfalto</span>}
                              {p.gasNatural && <span style={{ fontSize: "10px", background: "#f0fdf4", color: "#166534", padding: "2px 6px", borderRadius: "10px", border: "1px solid #bbf7d0" }}>Gas</span>}
                            </div>
                          )}
                          {p.precio > 0 ? (
                            <p style={{ fontSize: "14px", fontWeight: "700", color: "#1a9e2a", margin: "0 0 8px 0" }}>${p.precio.toLocaleString()}</p>
                          ) : (
                            <p style={{ fontSize: "12px", color: "#9ca3af", margin: "0 0 8px 0" }}>Consultar precio</p>
                          )}
                          <button onClick={() => navigate(`/propiedades/${p.id}`)} style={{ background: "#1a9e2a", color: "#fff", border: "none", borderRadius: "6px", padding: "6px 14px", fontWeight: "600", fontSize: "12px", cursor: "pointer", width: "100%" }}>
                            Ver detalle
                          </button>
                        </div>
                      </Popup>
                    </Marker>
                  ))}
                </MapContainer>
              </div>
            )}
          </div>
        )}

        {/* GRILLA */}
        {cargando ? (
          <p style={{ color: "#9ca3af", fontSize: "14px" }}>Cargando propiedades...</p>
        ) : filtradas.length === 0 ? (
          <p style={{ color: "#9ca3af", fontSize: "14px" }}>No hay propiedades que coincidan.</p>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "16px" }}>
            {filtradas.map((p) => {
              const imagenes = p.imagenes || (p.imagen ? [p.imagen] : []);
              const tipos = p.tipos || (p.tipo ? [p.tipo] : []);
              const esCampo = tipos.includes("Hectárea/Campo");
              const wapUrl = `https://wa.me/5493456458348?text=Hola%2C%20me%20interesa%20la%20propiedad%20*${encodeURIComponent(p.titulo)}*%20y%20quisiera%20consultar%20el%20precio.`;
              return (
                <div
                  key={p.id}
                  onClick={() => navigate(`/propiedades/${p.id}`)}
                  style={{ background: "#fff", borderRadius: "14px", overflow: "hidden", cursor: "pointer", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", transition: "box-shadow 0.2s", display: "flex", flexDirection: "column" }}
                  onMouseEnter={(ev) => { ev.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.12)"; }}
                  onMouseLeave={(ev) => { ev.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.08)"; }}
                >
                  <div style={{ position: "relative" }}>
                    <img src={imagenes[0] || "https://via.placeholder.com/300x200?text=Sin+foto"} alt={p.titulo} style={{ width: "100%", height: "200px", objectFit: "cover", display: "block" }} />
                    <div style={{ position: "absolute", top: "10px", left: "10px", display: "flex", gap: "6px", flexWrap: "wrap" }}>
                      {p.operacion && (
                        <span style={{ background: "#1a9e2a", color: "#fff", fontSize: "10px", padding: "3px 10px", borderRadius: "20px", fontWeight: "600" }}>
                          {p.operacion}
                        </span>
                      )}
                      {p.estado && p.estado !== "Disponible" && (
                        <span style={{ background: colorEstado(p.estado), color: "#fff", fontSize: "10px", padding: "3px 10px", borderRadius: "20px", fontWeight: "600" }}>
                          {p.estado}
                        </span>
                      )}
                    </div>
                  </div>

                  <div style={{ padding: "14px", display: "flex", flexDirection: "column", flex: 1 }}>
                    <h3 style={{ fontSize: "14px", fontWeight: "700", color: "#111827", marginBottom: "4px", lineHeight: "1.3" }}>
                      {p.numeroProp && (
                        <span style={{ fontSize: "10px", fontWeight: "700", color: "#1a3c5e", background: "#dbeafe", padding: "2px 6px", borderRadius: "6px", marginRight: "6px" }}>
                          P1{p.numeroProp}
                        </span>
                      )}
                      {p.titulo}
                    </h3>
                    <p style={{ fontSize: "12px", color: "#9ca3af", marginBottom: "8px" }}>{p.ubicacion}{p.barrio ? ` - ${p.barrio}` : ""}</p>
                    {p.descripcion && (
                      <p style={{ fontSize: "12px", color: "#6b7280", lineHeight: "1.6", marginBottom: "8px", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", flex: 1 }}>
                        {p.descripcion}
                      </p>
                    )}
                    {(p.ambientes || p.superficie) && (
                      <div style={{ display: "flex", gap: "10px", fontSize: "11px", color: "#9ca3af", marginBottom: "8px" }}>
                        {p.ambientes && <span>{p.ambientes} dorm.</span>}
                        {p.superficie && <span>{p.superficie} {esCampo ? "ha" : "m²"}</span>}
                      </div>
                    )}
                    {(p.asfalto || p.gasNatural) && (
                      <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "10px" }}>
                        {p.asfalto && <span style={{ fontSize: "10px", background: "#f0fdf4", color: "#166534", padding: "3px 8px", borderRadius: "10px", border: "1px solid #bbf7d0", fontWeight: "600" }}>Asfalto</span>}
                        {p.gasNatural && <span style={{ fontSize: "10px", background: "#f0fdf4", color: "#166534", padding: "3px 8px", borderRadius: "10px", border: "1px solid #bbf7d0", fontWeight: "600" }}>Gas</span>}
                      </div>
                    )}
                    <div style={{ borderTop: "1px solid #f3f4f6", paddingTop: "10px", display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "auto" }}>
                      {p.precio && p.precio > 0 ? (
                        <span style={{ fontSize: "16px", fontWeight: "700", color: "#1a9e2a" }}>${p.precio.toLocaleString()}</span>
                      ) : (
                        <a href={wapUrl} target="_blank" rel="noopener noreferrer" onClick={(ev) => ev.stopPropagation()} style={{ background: "#1a9e2a", color: "#fff", fontSize: "11px", padding: "5px 12px", borderRadius: "20px", fontWeight: "700", textDecoration: "none" }}>
                          $ Consultar
                        </a>
                      )}
                      <div style={{ display: "flex", gap: "4px", flexWrap: "wrap", justifyContent: "flex-end" }}>
                        {tipos.map((t) => (
                          <span key={t} style={{ fontSize: "11px", color: "#9ca3af", background: "#f3f4f6", padding: "3px 10px", borderRadius: "20px" }}>{t}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <footer style={{ borderTop: "3px solid #1a9e2a", padding: "20px 24px", textAlign: "center", color: "#9ca3af", fontSize: "12px", marginTop: "40px", background: "#f4f4f4" }}>
        Confalonieri Propiedades - Sarmiento 2750, Chajari - Todos los derechos reservados
      </footer>

    </div>
  );
}
